var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowHoveri = function SvgArrowHoveri(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 10,
    fill: props.color || 'currentColor'
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11.5,
    fill: "none",
    stroke: "#f7f8f9",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.8 11 13 14.7 9.2 11 8 12.1l5 4.9 5-4.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowHoveri);
export default ForwardRef;